/** Galerie commune aux cartes SSR, moteur, recommandations et wishlist.
 * Le premier img reste dans le HTML. Une seule photo suivante est anticipée,
 * après chargement des photos prioritaires et de la courante. Deux anticipations
 * au plus tournent en parallèle ; un choix explicite reste immédiat.
 */
(function () {
  'use strict';
  var selector = '.pc4[data-product-id]';
  var states = new WeakMap();
  var products = new Map();
  var source = document.querySelector('[data-jaiio-card-gallery]');
  var widths = [200, 300, 400, 500, 600, 800, 1000];
  var jsonQueue = [], activeJson = 0;
  var imageQueue = [], activeImages = 0;
  var priorityImages = new Set(), trackedImages = new WeakSet(), deferredStates = new Set();
  var swipe = null;
  var arrow = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function esc(value) {
    return String(value || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function text(key, fallback) { return source && source.getAttribute('data-media-' + key) || fallback; }
  function path(url) { try { return new URL(url, location.href).pathname; } catch (e) { return ''; } }
  function imageUrl(url, width) {
    var value = new URL(url, location.href);
    value.searchParams.set('width', width);
    return value.href;
  }
  function responsive(image, media, sizes) {
    image.sizes = sizes || '(max-width: 740px) 200px, 280px';
    image.srcset = widths.map(function (w) { return imageUrl(media.url, w) + ' ' + w + 'w'; }).join(', ');
    image.src = imageUrl(media.url, 600);
  }
  function ordered(state, media) {
    var seen = {};
    media = media.filter(function (item) {
      if (!item || !item.url || seen[path(item.url)]) return false;
      seen[path(item.url)] = true;
      return true;
    });
    var first = media.findIndex(function (item) { return path(item.url) === state.initial; });
    if (first > 0) media.unshift(media.splice(first, 1)[0]);
    return media.slice(0, 5);
  }
  function pumpJson() {
    while (activeJson < 4 && jsonQueue.length) {
      var job = jsonQueue.shift();
      activeJson++;
      job();
    }
  }
  function productKeys(state) {
    var keys = [], id = state.card.getAttribute('data-product-id');
    if (id) keys.push('id:' + id.replace(/^gid:\/\/shopify\/Product\//i, ''));
    var link = state.card.querySelector('.product-item__aspect-ratio[href]');
    if (!link) return keys;
    var url = new URL(link.getAttribute('href'), location.href);
    if (url.origin !== location.origin) return keys;
    url.search = ''; url.hash = '';
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    keys.push(url.pathname);
    return keys;
  }
  function rememberMedia(state, media) {
    if (!media.length) return;
    // Les cartes moteur peuvent revenir avec une autre URL pour le même produit.
    // Conserver les graines Liquid même après le retrait de leur carte évite les GET.
    var cached = Promise.resolve(media);
    productKeys(state).forEach(function (key) { products.set(key, cached); });
  }
  function productMedia(state) {
    var keys = productKeys(state);
    for (var i = 0; i < keys.length; i++) {
      if (products.has(keys[i])) {
        var cached = products.get(keys[i]);
        keys.forEach(function (alias) { products.set(alias, cached); });
        return cached;
      }
    }
    var key = keys.find(function (value) { return value.charAt(0) === '/'; });
    if (!key) return Promise.resolve([]);
    var pending = new Promise(function (resolve) {
      jsonQueue.push(function () {
        fetch(key, { credentials: 'same-origin', priority: 'low', headers: { Accept: 'application/json' } })
          .then(function (response) { if (!response.ok) throw new Error('media'); return response.json(); })
          .then(function (product) {
            var media = Array.isArray(product.media) ? product.media.filter(function (m) {
              return m.media_type === 'image' && m.preview_image && m.preview_image.src;
            }).map(function (m) { return { url: m.preview_image.src, alt: m.alt || product.title }; }) :
              (product.images || []).map(function (m) { return { url: typeof m === 'string' ? m : m.src, alt: product.title }; });
            resolve(media);
          }).catch(function () {
            keys.forEach(function (alias) { if (products.get(alias) === pending) products.delete(alias); });
            resolve([]);
          })
          .finally(function () { activeJson--; pumpJson(); });
      });
      pumpJson();
    });
    keys.forEach(function (alias) { products.set(alias, pending); });
    return pending;
  }
  function backgroundReady() {
    priorityImages.forEach(function (image) {
      if (!image.isConnected || image.complete) priorityImages.delete(image);
    });
    return priorityImages.size === 0;
  }
  function resumeBackground() {
    if (!backgroundReady()) return;
    deferredStates.forEach(function (state) { deferredStates.delete(state); anticipate(state); });
    pumpImages();
  }
  function trackPriorityImages(root) {
    var selector = '.product-item__primary-image[fetchpriority="high"]';
    var images = root.matches && root.matches(selector) ? [root] : [];
    root.querySelectorAll(selector).forEach(function (image) { images.push(image); });
    images.forEach(function (image) {
      if (trackedImages.has(image)) return;
      trackedImages.add(image);
      if (image.complete) return;
      priorityImages.add(image);
      function settled() {
        priorityImages.delete(image);
        image.removeEventListener('load', settled);
        image.removeEventListener('error', settled);
        resumeBackground();
      }
      image.addEventListener('load', settled);
      image.addEventListener('error', settled);
    });
  }
  function pumpImages() {
    if (!backgroundReady()) return;
    while (activeImages < 2 && imageQueue.length) {
      var job = imageQueue.shift();
      if (job.started) continue;
      if (!job.state.active || !job.state.card.isConnected) job.cancel();
      else job.start(true);
    }
  }
  function renderNav(state) {
    var nav = state.nav, count = state.media.length;
    nav.hidden = count < 2;
    if (count < 2 || nav.querySelectorAll('[data-card-media-dot]').length === count) return;
    nav.innerHTML = '<button type="button" class="dots__arrow dots__arrow--prev" data-card-media-step="-1" aria-label="' + esc(text('prev', 'Image précédente')) + '">' + arrow + '</button>' +
      '<span class="dots__row">' + state.media.map(function (_, index) {
        var label = text('dot', "Afficher l'image %index% sur %total%").replace('%index%', index + 1).replace('%total%', count);
        return '<button type="button" class="product-item__media-dot" data-card-media-dot="' + index + '"' + (index === state.current ? ' aria-current="true"' : '') + ' aria-label="' + esc(label) + '"></button>';
      }).join('') + '</span>' +
      '<button type="button" class="dots__arrow dots__arrow--next" data-card-media-step="1" aria-label="' + esc(text('next', 'Image suivante')) + '">' + arrow + '</button>';
  }
  function prepare(state) {
    if (state.media.length) return Promise.resolve(state.media);
    if (!state.pending) state.pending = productMedia(state).then(function (media) {
      state.media = ordered(state, media);
      state.pending = null;
      renderNav(state);
      return state.media;
    });
    return state.pending;
  }
  // Même candidat responsive que l'image qui sera affichée ; priorité basse,
  // sans insertion DOM ni modification de la photo principale indexable.
  function load(state, index, urgent) {
    var sizes = state.image.getAttribute('sizes');
    var key = index + ':' + sizes + ':' + window.innerWidth + ':' + window.devicePixelRatio;
    if (!state.loads.has(key)) {
      var resolveLoad, rejectLoad;
      var pending = new Promise(function (resolve, reject) { resolveLoad = resolve; rejectLoad = reject; });
      var job = { state: state, promise: pending, started: false };
      job.cancel = function () { state.loads.delete(key); rejectLoad(new Error('inactive')); };
      job.start = function (background) {
        if (job.started) return;
        job.started = true;
        if (background) activeImages++;
        var finished = false;
        function finish(error, image) {
          if (finished) return;
          finished = true;
          if (background) activeImages--;
          if (error) { state.loads.delete(key); rejectLoad(error); }
          else resolveLoad(image);
          pumpImages();
        }
        var image = new Image();
        image.decoding = 'async';
        image.fetchPriority = 'low';
        image.onload = function () {
          var decoded = typeof image.decode === 'function' ? image.decode().catch(function () {}) : Promise.resolve();
          decoded.then(function () { finish(null, image); });
        };
        image.onerror = function () { finish(new Error('image')); };
        responsive(image, state.media[index], sizes);
      };
      state.loads.set(key, job);
      if (!urgent) imageQueue.push(job);
    }
    var queued = state.loads.get(key);
    // Un clic sur une photo déjà en file ne doit pas attendre les autres cartes.
    if (urgent) queued.start(false);
    else pumpImages();
    return queued.promise;
  }
  function anticipate(state) {
    if (!state.active || !state.card.isConnected) return;
    if (!backgroundReady()) { deferredStates.add(state); return; }
    prepare(state).then(function (media) {
      // Les repères doivent permettre de choisir une autre photo même si la
      // primaire est cassée ; seule l'anticipation attend une photo affichable.
      if (media.length > 1 && state.active && state.card.isConnected && state.image.complete && state.image.naturalWidth) {
        load(state, (state.current + 1) % media.length).catch(function () {});
      }
    });
  }
  function activate(state) { state.active = true; anticipate(state); }
  var observer = typeof IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = states.get(entry.target);
      if (!state) return;
      if (entry.isIntersecting) activate(state);
      else state.active = false;
    });
  }, { rootMargin: '200px' }) : null;
  function init(card) {
    if (states.has(card)) { if (observer) observer.observe(card); return states.get(card); }
    var image = card.querySelector('.product-item__primary-image');
    var nav = card.querySelector('[data-card-media-nav]');
    if (!image || !nav) return null;
    var current = Number(card.getAttribute('data-card-media-index') || 0);
    var state = { card: card, image: image, nav: nav, current: current, desired: current, revision: 0,
      initial: path(image.getAttribute('src')), media: [], loads: new Map(), active: false, suppressUntil: 0 };
    try { state.media = ordered(state, JSON.parse(nav.getAttribute('data-card-media') || '[]')); } catch (e) { /* API fallback */ }
    rememberMedia(state, state.media);
    states.set(card, state);
    renderNav(state);
    image.addEventListener('load', function () { anticipate(state); });
    if (observer) observer.observe(card);
    else activate(state);
    return state;
  }
  function select(state, requested) {
    if (!state) return;
    state.active = true;
    state.desired = requested;
    var revision = ++state.revision;
    prepare(state).then(function (media) {
      if (media.length < 2 || revision !== state.revision) return;
      var index = (requested % media.length + media.length) % media.length;
      state.desired = index;
      if (index === state.current) { state.nav.removeAttribute('aria-busy'); return; }
      state.nav.setAttribute('aria-busy', 'true');
      return load(state, index, true).then(function (loaded) {
        if (revision !== state.revision || !state.card.isConnected) return;
        state.current = index;
        state.card.setAttribute('data-card-media-index', index);
        state.image.decoding = 'async';
        state.image.loading = 'eager';
        // La photo précédente reste affichée jusqu'à ce que la cible soit prête.
        state.image.alt = media[index].alt || state.image.alt;
        state.image.sizes = loaded.sizes;
        state.image.srcset = loaded.srcset;
        state.image.src = loaded.src;
        state.nav.removeAttribute('aria-busy');
        state.nav.querySelectorAll('[data-card-media-dot]').forEach(function (dot) {
          if (Number(dot.getAttribute('data-card-media-dot')) === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        anticipate(state);
      });
    }).catch(function () {
      if (revision === state.revision) { state.desired = state.current; state.nav.removeAttribute('aria-busy'); }
    });
  }
  function release(root) {
    if (root.nodeType !== 1) return;
    function remove(card) {
      if (observer) observer.unobserve(card);
      var state = states.get(card);
      if (state) { state.active = false; deferredStates.delete(state); }
    }
    if (root.matches(selector)) remove(root);
    root.querySelectorAll(selector).forEach(remove);
  }
  function scan(root) {
    if (root.nodeType !== 1 && root !== document) return;
    trackPriorityImages(root);
    if (root.matches && root.matches(selector)) init(root);
    root.querySelectorAll(selector).forEach(init);
  }
  scan(document);
  new MutationObserver(function (records) {
    records.forEach(function (record) { record.removedNodes.forEach(release); record.addedNodes.forEach(scan); });
    resumeBackground();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('pointerover', function (event) {
    if (event.pointerType && event.pointerType !== 'mouse') return;
    var wrapper = event.target.closest('.pc4 .product-item__image-wrapper');
    if (!wrapper || event.relatedTarget && wrapper.contains(event.relatedTarget)) return;
    var state = init(wrapper.closest(selector));
    if (state) activate(state);
  });
  document.addEventListener('focusin', function (event) {
    var card = event.target.closest(selector);
    if (card) { var state = init(card); if (state) activate(state); }
  });
  document.addEventListener('click', function (event) {
    var card = event.target.closest(selector);
    var state = card && init(card);
    if (!state) return;
    var control = event.target.closest('[data-card-media-step], [data-card-media-dot]');
    if (control) {
      event.preventDefault(); event.stopImmediatePropagation();
      select(state, control.hasAttribute('data-card-media-step') ? state.desired + Number(control.getAttribute('data-card-media-step')) : Number(control.getAttribute('data-card-media-dot')));
    } else if (Date.now() < state.suppressUntil && event.target.closest('.product-item__aspect-ratio')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'mouse' || !event.isPrimary) return;
    var link = event.target.closest('.pc4 .product-item__aspect-ratio');
    if (!link) return;
    var state = init(link.closest(selector));
    if (state) { activate(state); swipe = { state: state, id: event.pointerId, x: event.clientX, y: event.clientY }; }
  });
  document.addEventListener('pointerup', function (event) {
    if (!swipe || swipe.id !== event.pointerId) return;
    var gesture = swipe; swipe = null;
    var dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
    if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
    event.preventDefault();
    gesture.state.suppressUntil = Date.now() + 500;
    select(gesture.state, gesture.state.desired + (dx < 0 ? 1 : -1));
  });
  document.addEventListener('pointercancel', function () { swipe = null; });
})();
